import { useCallback } from 'react';
import QueryString from 'qs';
import { API } from '../api';
import { Utils } from '../helpers/Utils';
import { usePaginatedList } from './usePaginatedList';

const PAGE_SIZE = 25;

const buildEventsQuery = (page) =>
    QueryString.stringify({
        pagination: {
            page,
            pageSize: PAGE_SIZE,
        },
    });

export const buildInitialEventsQuery = () => buildEventsQuery(1);

const fetchEventsPage = async (page) => {
    const response = await API.get(
        `/api/coach-summary?${buildEventsQuery(page)}`,
    );
    return {
        items: Utils.deepFlatten(response.data.data ?? []),
        pagination: response.data.meta?.pagination,
    };
};

export const useEventsInfinite = (initialEvents, initialPagination) => {
    const fetchPage = useCallback((page) => fetchEventsPage(page), []);

    const { items, loadMore, loading, hasMore } = usePaginatedList({
        fetchPage,
        initialItems: initialEvents,
        initialPagination,
    });

    return { allEvents: items, loadMore, loading, hasMore };
};
